module.exports = "<div ncy-breadcrumb></div> <seller-total-price-discounts discounts=vm.productOverviewModel.totalPriceDiscounts></seller-total-price-discounts> <product-overview context=seller-discounts-overview model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/seller/discounts.html
// module id = 671
// module chunks = 0